import { Dropdown } from 'primereact/dropdown';
import {
  PaginatorCurrentPageReportOptions,
  PaginatorRowsPerPageDropdownOptions,
} from 'primereact/paginator';
import { Fragment, useEffect } from 'react';
import { dropdownOptions, Option } from './DataTable.type';
import { useDataTableStore } from '@/store/DataTableStore/DataTableStore';

const renderOption = (option: Option) => (
  <div className="flex items-center px-3 py-2 cursor-pointer hover:bg-primary hover:text-white transition duration-150 ease-in-out bg-[#232323]">
    <div className="text-white">{option.value}</div>
  </div>
);

const renderSelectedItem = (option: Option) => {
  return (
    option && (
      <div className="flex items-center px-3 py-2 text-white rounded-md">
        <div>{option.value}</div>
      </div>
    )
  );
};

export const paginationTemplate = (currentPage: number) => {
  return {
    layout: 'RowsPerPageDropdown CurrentPageReport',
    RowsPerPageDropdown: (options: PaginatorRowsPerPageDropdownOptions) => {
      return (
        <Fragment>
          <span
            className="mx-1 text-white font-raleway"
            style={{ userSelect: 'none' }}
          >
            Elements par page :{' '}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
            unstyled
            itemTemplate={renderOption}
            valueTemplate={renderSelectedItem}
            className="flex flex-row items-center gap-1 pr-2 ml-1 border text-white rounded-md font-raleway"
            panelStyle={{ marginTop: '8px' }}
          />
        </Fragment>
      );
    },

    CurrentPageReport: (options: PaginatorCurrentPageReportOptions) => {
      const { setCurrentPageValue } = useDataTableStore();

      useEffect(() => {
        setCurrentPageValue(options.totalPages);
      }, [options.totalPages, setCurrentPageValue]);

      return (
        <span
          className="text-white font-raleway"
          style={{
            userSelect: 'none',
            textAlign: 'center',
            marginLeft: '0.625rem',
          }}
        >
          {currentPage} - {options.totalPages} de {options.totalRecords}
        </span>
      );
    },
  };
};
